export default {
  "home": "홈",
  "news": "최신 정보",
  "community": "커뮤니티",
  "character": "캐릭터",
  "world": "세계관",
  "features": "게임 소개",
  "topUp": "충전",
  "customerService": "고객센터",
  "download": "다운로드",
  "moreDownload": "더 보기",
  "screenshot": "스크린샷",
  "video": "동영상",
  "poster": "포스터",
  "downloadGame": "다운로드",
  "scan": "QR코드를 스캔하세요",
  "prev": "이전",
  "next": "다음",
  "moreNews": "더 보기",
  "latest": "최신",
  "fwtk": "서비스 약관",
  "yszc": "개인정보 취급 방침",
  "noContent": "준비 중",
  "goPay": "이동",
  "payGuide": "확인",
  "stayTurn": "준비 중",
  "back": "돌아가기",

}
